(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pa-chat-entrypoints"] && !Shopify.designMode) return;
  try {
    (() => {
  const labels = document.getElementById('pa-chat-labels');
  if (!labels) return;
  const observed = new WeakSet();
  let queued = false;
  const inboxStyle = `
    .activator-nudge {
      position: fixed !important; inset: auto 200px calc(20px + env(safe-area-inset-bottom, 0px)) auto !important;
      width: 180px !important; transform: none !important;
    }
    .activator {
      box-sizing: border-box !important; width: 180px !important; min-height: 48px !important;
      padding: 10px 16px !important; border-radius: 28px !important;
      background: #1f4054 !important; color: #fff !important;
      font-size: 14px !important; line-height: 1.3 !important;
    }
    .activator:focus-visible { outline: 3px solid #76b8b0 !important; outline-offset: 3px !important; }
    .activator__label { display: block !important; white-space: nowrap !important; }
    @media (max-width: 600px) {
      .activator-nudge { left: 12px !important; right: auto !important;
        bottom: calc(10px + env(safe-area-inset-bottom, 0px)) !important;
        width: calc((100vw - 32px) / 2) !important; }
      .activator { width: 100% !important; height: 48px !important; padding: 7px 12px !important; font-size: 13px !important; }
    }
  `;
  const respondStyle = `
    .container.container--fixed { right: 20px !important; left: auto !important;
      bottom: calc(20px + env(safe-area-inset-bottom, 0px)) !important; transform: none !important; }
    .speed-dial .speed-dial__button-root { width: 172px !important; height: 48px !important;
      border-radius: 28px !important; padding: 10px 16px !important; gap: 8px !important;
      background: #1f4054 !important; color: #fff !important; font-size: 14px !important;
      line-height: 1.3 !important; font-weight: 500 !important; }
    .speed-dial__button-root .root-icon svg { width: 22px !important; height: 22px !important; padding: 0 !important; }
    .speed-dial__button-root > .speed-dial__caption { display: none !important; }
    .speed-dial__button-root .pa-chat-label { white-space: nowrap; }
    .speed-dial__button-root.open .root-icon { display: none !important; }
    .speed-dial__button-root .close.open { position: static !important; display: flex !important; }
    .speed-dial__button-root .close.open svg { width: 22px !important; height: 22px !important; }
    .speed-dial [data-direction] { right: 0; align-items: flex-end; }
    .speed-dial__button-root:focus-visible { outline: 3px solid #76b8b0 !important; outline-offset: 3px !important; }
    @media (max-width: 600px) {
      .container.container--fixed { right: 12px !important;
        bottom: calc(10px + env(safe-area-inset-bottom, 0px)) !important; }
      .speed-dial .speed-dial__button-root { width: calc((100vw - 32px) / 2) !important;
        padding: 10px 12px !important; font-size: 13px !important; }
    }
  `;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; sync(); });
  }
  function observe(root) {
    if (!root || observed.has(root)) return;
    observed.add(root);
    new MutationObserver(schedule).observe(root, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['open', 'class', 'aria-label', 'aria-expanded']
    });
  }
  function style(root, css) {
    if (root.querySelector('#pa-chat-entrypoint-style')) return;
    const el = document.createElement('style');
    el.id = 'pa-chat-entrypoint-style';
    el.textContent = css;
    root.append(el);
  }
  function setState(name, state) {
    if (document.documentElement.classList.contains(name) !== state)
      document.documentElement.classList.toggle(name, state);
  }
  function sync() {
    const chat = document.querySelector('shopify-chat');
    const root = chat?.shadowRoot;
    observe(root);
    const runtime = root?.querySelector('shopify-agent-runtime');
    const roots = [root, runtime?.shadowRoot].filter(Boolean);
    for (const r of roots) {
      observe(r);
      const button = r.querySelector('button[part~="activator"]');
      const label = button?.querySelector('.activator__label');
      if (!button || !label) continue;
      if (label.textContent !== labels.dataset.inbox) label.textContent = labels.dataset.inbox;
      if (button.getAttribute('aria-label') !== labels.dataset.inbox) button.setAttribute('aria-label', labels.dataset.inbox);
      style(r, inboxStyle);
    }
    setState('pa-inbox-open', Boolean(chat?.hasAttribute('open') || runtime?.hasAttribute('open')));
    const respond = document.querySelector('respond-io-widget')?.shadowRoot;
    observe(respond);
    const button = respond?.querySelector('.speed-dial__button-root');
    if (button) {
      let label = button.querySelector('.pa-chat-label');
      if (!label) { label = document.createElement('span'); label.className = 'pa-chat-label'; button.append(label); }
      if (label.textContent !== labels.dataset.respond) label.textContent = labels.dataset.respond;
      if (button.getAttribute('aria-label') !== labels.dataset.respond) button.setAttribute('aria-label', labels.dataset.respond);
      const open = button.classList.contains('open');
      if (button.getAttribute('aria-expanded') !== String(open)) button.setAttribute('aria-expanded', String(open));
      style(respond, respondStyle);
      setState('pa-respond-open', open);
    } else setState('pa-respond-open', false);
  }
  observe(document.documentElement);
  sync();
  // Shadow roots can appear after their hosts. Bounded startup checks cover that gap.
  let remaining = 120;
  const startup = setInterval(() => { sync(); if (--remaining <= 0) clearInterval(startup); }, 500);
})();
  } catch(e) { console.error(e); }
})();

})();
